import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <CollegeFootball
    {...props}
    team="South Carolina Gamecocks"
    teamId={teamIds['South Carolina Gamecocks']}
  />
)
